import React from "react";

export const Completion = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-133.000000, -155.000000)" fill="#353F52">
        <g transform="translate(133.000000, 155.000000)">
          <path
            d="M39,41 C38.4477,41 38,41.4477 38,42 C38,42.5523 38.4477,43 39,43 L43.382,43 L40.1056,49.5528 C39.8586,50.0468 40.0588,50.6474 40.5528,50.8944 C41.0468,51.1414 41.6474,50.9412 41.8944,50.4472 L45.8944,42.4472 C46.0494,42.1372 46.0329,41.7691 45.8507,41.4743 C45.6684,41.1795 45.3466,41 45,41 L39,41 Z"
            fillRule="nonzero"
          />
          <path d="M33,28 C33.5523,28 34,28.4477 34,29 L34,30 L38,30 L38,29 C38,28.4477 38.4477,28 39,28 C39.5523,28 40,28.4477 40,29 L40,30 L44,30 L44,29 C44,28.4477 44.4477,28 45,28 C45.5523,28 46,28.4477 46,29 L46,30 L50,30 L50,29 C50,28.4477 50.4477,28 51,28 C51.5523,28 52,28.4477 52,29 L52,30 L53,30 C54.6569,30 56,31.3431 56,33 L56,53 C56,54.6569 54.6569,56 53,56 L31,56 C29.3431,56 28,54.6569 28,53 L28,33 C28,31.3431 29.3431,30 31,30 L32,30 L32,29 C32,28.4477 32.4477,28 33,28 Z M32,33 L32,32 L31,32 C30.4477,32 30,32.4477 30,33 L30,36 L54,36 L54,33 C54,32.4477 53.5523,32 53,32 L52,32 L52,33 C52,33.5523 51.5523,34 51,34 C50.4477,34 50,33.5523 50,33 L50,32 L46,32 L46,33 C46,33.5523 45.5523,34 45,34 C44.4477,34 44,33.5523 44,33 L44,32 L40,32 L40,33 C40,33.5523 39.5523,34 39,34 C38.4477,34 38,33.5523 38,33 L38,32 L34,32 L34,33 C34,33.5523 33.5523,34 33,34 C32.4477,34 32,33.5523 32,33 Z M30,53 L30,38 L54,38 L54,53 C54,53.5523 53.5523,54 53,54 L31,54 C30.4477,54 30,53.5523 30,53 Z" />
          <path d="M16,36 L2,36 L2,54 L16,54 L16,36 Z M2,34 C0.89543,34 0,34.8954 0,36 L0,54 C0,55.1046 0.89543,56 2,56 L16,56 C17.1046,56 18,55.1046 18,54 L18,36 C18,34.8954 17.1046,34 16,34 L2,34 Z" />
          <path
            d="M22,22 L47,22 L47,25 C47,25.5523 47.4477,26 48,26 C48.5523,26 49,25.5523 49,25 L49,22 C49,20.8954 48.1046,20 47,20 L22,20 C20.8954,20 20,20.8954 20,22 L20,54 C20,55.1046 20.8954,56 22,56 L25,56 C25.5523,56 26,55.5523 26,55 C26,54.4477 25.5523,54 25,54 L22,54 L22,22 Z"
            fillRule="nonzero"
          />
          <path
            d="M29,2 L9,2 L9,31 C9,31.5523 8.5523,32 8,32 C7.4477,32 7,31.5523 7,31 L7,2 C7,0.89543 7.8954,0 9,0 L29,0 C30.1046,0 31,0.89543 31,2 L31,17 C31,17.5523 30.5523,18 30,18 C29.4477,18 29,17.5523 29,17 L29,2 Z"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);
